import { render } from "./StockTraderPro.vue?vue&type=template&id=0013c36c&scoped=true"
import script from "./StockTraderPro.vue?vue&type=script&lang=js"
export * from "./StockTraderPro.vue?vue&type=script&lang=js"

import "./StockTraderPro.vue?vue&type=style&index=0&id=0013c36c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0013c36c"]])

export default __exports__